import { render, staticRenderFns } from "./VirtualDeviceItem.vue?vue&type=template&id=0c3d375f&scoped=true&"
import script from "./VirtualDeviceItem.vue?vue&type=script&lang=js&"
export * from "./VirtualDeviceItem.vue?vue&type=script&lang=js&"
import style0 from "./VirtualDeviceItem.vue?vue&type=style&index=0&id=0c3d375f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d375f",
  null
  
)

export default component.exports